import React, { useState } from "react";

import { presentations as presentationsApi } from "apis/callables";
import { PresentationActivityType } from "common/interfaces";
import PresentationLibraryPaneController, { PresentationLibraryFilterType } from "js/controllers/PresentationLibraryPaneController";
import AppController from "js/core/AppController";
import { trackActivity } from "js/core/utilities/utilities";
import { CreatePresentationDialogPaneType } from "js/editor/CreatePresentation/CreatePresentationDialogTypes";
import LibraryStarterTemplatesPaneLayout from "js/editor/PresentationLibrary/LibraryStarterTemplatesPaneLayout";
import { LibraryTeamTemplatesPaneInner } from "js/editor/PresentationLibrary/LibraryTeamTemplatesPane";
import {
    LibraryTemplateCreateOptions,
    LibraryTemplatesPaneProps,
} from "js/editor/PresentationLibrary/libraryTemplatesPaneShared";
import { app } from "js/namespaces";

export function LibraryTemplatesPane(props: LibraryTemplatesPaneProps) {
    const [isCreatingPresentation, setIsCreatingPresentation] = useState(false);

    const handleCreatePresentation = async (options: LibraryTemplateCreateOptions) => {
        if (isCreatingPresentation) {
            return;
        }

        setIsCreatingPresentation(true);

        try {
            const workspaceId = AppController.workspaceId;
            const libraryFilter = {
                type: PresentationLibraryFilterType.ALL_PRESENTATIONS,
                folderId: null,
                subFolderId: null,
            };

            let createdPresentation;
            if (options.type === "starter-template") {
                createdPresentation = await PresentationLibraryPaneController.createPresentationFromStarterTemplate({
                    workspaceId,
                    libraryFilter,
                    starterTemplateId: options.templateId,
                });
                trackActivity("Presentation", "GetDeck", null, null, {
                    presentationId: options.templateId,
                    source: "template",
                }, { audit: true });
            } else {
                createdPresentation = await PresentationLibraryPaneController.createPresentationFromTemplate({
                    templatePresentationId: options.templateId,
                    libraryFilter,
                });
            }

            await presentationsApi.recordActivity({
                id: createdPresentation.id,
                activity: PresentationActivityType.CREATED,
                activityData: { creationType: options.type },
            });

            if (!app.user.get("firstPresentationId")) {
                app.user.update({ firstPresentationId: createdPresentation.id });
                await app.user.updatePromise;
            }

            AppController.showEditor({ presentationId: createdPresentation.id });
        } finally {
            setIsCreatingPresentation(false);
        }
    };

    const layoutProps = {
        ...props,
        onCreate: handleCreatePresentation,
        isCreatingPresentation,
    };

    if (props.pane === CreatePresentationDialogPaneType.STARTER_TEMPLATES) {
        return <LibraryStarterTemplatesPaneLayout {...layoutProps} />;
    }

    return <LibraryTeamTemplatesPaneInner {...layoutProps} />;
}
